export default "__VITE_ASSET__DmV8flmr__"